import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vc-incoming-hero" }
const _hoisted_2 = { class: "vc-incoming-hero__title text-wrap" }
const _hoisted_3 = { class: "vc-incoming-hero__purpose text-wrap" }
const _hoisted_4 = { class: "vc-incoming-hero__connecting" }
const _hoisted_5 = { class: "mb-16" }

import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useCallStore } from '../stores/callStore'
import PatientBackground from '../components/PatientBackground.vue'
import { incomingPurposeLine } from '@virtual-care/shared'

interface Props {
  sessionId: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectingView',
  props: {
    sessionId: {}
  },
  setup(__props: any) {

/**
 * Brief flash before ActiveCallView; matches Figma connecting variants.
 */
const props = __props
const router = useRouter()
const callStore = useCallStore()

const minimalLayout = process.env.VUE_APP_CONNECTING_LAYOUT === 'minimal'

const nurseName = computed(() => callStore.nurseName ?? 'your nurse')
const headline = computed(() => `Connecting to ${nurseName.value}...`)
const purposeLine = computed(() => incomingPurposeLine(callStore.callPurpose))

onMounted(async () => {
  // Small delay to let the previous router transition (incoming → connecting) complete
  // before navigating again. Without this, Vue Router can mount/unmount ActiveCallView
  // multiple times in rapid succession, causing useVideoClient to initialize and dispose
  // repeatedly, which closes the Zoom session prematurely.
  await new Promise(resolve => setTimeout(resolve, 100))
  router.replace(`/call/${props.sessionId}`)
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height bg-backgroundBase vc-incoming-root vc-tv-canvas-bg"
  }, {
    default: _withCtx(() => [
      _createVNode(PatientBackground),
      (!minimalLayout)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h1", _hoisted_2, _toDisplayString(headline.value), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(purposeLine.value), 1),
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "vc-incoming-hero__connecting-text" }, "Connecting you now...", -1)),
                _createVNode(_component_v_progress_circular, {
                  color: "primary",
                  indeterminate: "",
                  size: "48",
                  width: "4"
                })
              ])
            ]),
            _createVNode(_component_v_sheet, {
              class: "vc-incoming-panel vc-connecting-panel d-flex flex-column bg-white",
              elevation: "24",
              height: "100%",
              rounded: "0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_icon, {
                    class: "vc-rail__video-icon",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-video-plus-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "flex-grow-1",
                  "aria-hidden": "true"
                }, null, -1))
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 1,
            class: "vc-incoming-panel vc-connecting-panel vc-connecting-rail--minimal d-flex flex-column bg-white",
            elevation: "24",
            height: "100%",
            rounded: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                class: "vc-rail__video-icon mb-4",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-video-plus-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "vc-minimal-connecting-label mb-6" }, "Connecting you now...", -1)),
              _createVNode(_component_v_progress_circular, {
                color: "primary",
                indeterminate: "",
                size: "48",
                width: "4"
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})